<template>
    <!-- 公司文化 -->
    <div class="main">
        <div class="content">
            <sub-title
                title="相关下载"
                class="title"
            ></sub-title>

            <div class="inner-content">
                <table class="table">
                    <tr>
                        <td>#</td>
                        <td>文件名称</td>
                        <td>下载</td>
                        <td>使用范围</td>
                    </tr>

                    <tr v-for="(row, index) in webInfo.about.xgxz" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{row.title}}</td>
                        <td>
                            <a :href="row.urlname" target="_blank">免费下载</a>
                        </td>
                        <td>
                            {{row.infoa || '-'}}
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import SubTitle from './sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
          
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.main {
    width: 100%;
    background-image: linear-gradient(#EAF2FF, white);
    padding-top: 93px;

    .inner-content {
        width: 100%;
        display: flex;
        padding: 40px;
        margin-top: 65px;
        background: #fff;

        .table{
            width: 100%;
            border-left: 1px solid #ebeef5;
            border-top: 1px solid #ebeef5;

            tr{
                
            }

            td{
                padding: 12px 10px;
                border-right: 1px solid #ebeef5;
                border-bottom: 1px solid #ebeef5;
            }

            a {
                color: #107eec;
            }
        }
    }
}
</style>
